<template>
    <div class="footer">
            <div class="wrap-c">
                <div class="leaderboard">
                    <div class="weekly-board" v-for="(item,index) in leaderboardArr" :key="index">
                        <h3 class="weekly-title">{{ item.title }}</h3>
                        <p>( {{ 'By ' + item.endTime }} )</p>
                        <div class="board-table">
                            <el-table
                                :data="item.tableData"
                                style="width: 100%">
                                <el-table-column
                                    align="center"
                                    prop="name"
                                    label="Name"
                                    :width="tableColumnWidth">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="inviteNum"
                                    label="Referrals"
                                    :width="tableColumnWidth">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="inviteEarnings"
                                    label="Earning"
                                    >
                                    <template #default="scope">
                                        {{ `$${scope.row.inviteEarnings}.00` }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script lang="ts">
import { timestampToTime, getUrlKey } from "@/utils/index"
import { defineComponent,toRefs,reactive } from 'vue';

export default defineComponent({
  setup(){
      interface DataProps{
        leaderboardArr:any;
      }
      const data:DataProps = reactive({
            tableColumnWidth: window.screen.width < 500 ? '100' : '140',
            leaderboardArr:[
                {
                    title: 'All-time Leaderboard',
                    startTime: '',
                    endTime: 'May.10',
                    tableData:[
                        {
                            name: 'Ke***.J',
                            inviteNum: '207',
                            inviteEarnings: '628'
                        },
                        {
                            name: 'Jo**.S',
                            inviteNum: '181',
                            inviteEarnings: '550'
                        },
                        {
                            name: 'Gr***.G',
                            inviteNum: '155',
                            inviteEarnings: '472'
                        }
                    ]
                },
            ]
      })
      const refData = toRefs(data)
      return {
          ...refData
      }
  }
})
</script>
<style lang="scss" scoped>
/deep/ .el-table th.is-leaf {
    border-bottom: 1px solid #e8e8e8;
}
/deep/ .el-table td{
    border-bottom: 1px solid #e8e8e8;
}
::v-deep .el-divider{
    background-color: #e8e8e8;
}
.wrap-c {
    max-width: 1024px;
    margin: 0 auto;
    height: 100%;
    overflow: hidden;
}
 .footer{
    background-color: #f2f2f2;
    padding: 20px 0;
    .leaderboard{
        display: flex;
        justify-content: space-around;
        .weekly-board{
            margin: 0 20px;
            background-color: #fff;
            width: 50%;
            padding: 20px 60px;
            &:first-child{
                margin-left: 0;
            }
            &:last-child{
                margin-right: 0;
            }
            .weekly-title{
                font-weight: 500;
                margin-bottom: 6px;
            }
            .board-table{
                margin-top: 10px;
            }
        }
    }
    .descript-list{
        color: #9E9E9F;
        text-align: left;
        font-size: 14px;
        .item{
            margin-top: 8px;
        }
    }
}
@media screen and (max-width: 768px){
    .wrap-c{
        padding: 0 10px;
    }
    .footer{
        .leaderboard{
            flex-wrap: wrap;
            .weekly-board{
                width: 90%;
                margin: 0 0 20px 0;
                 padding: 20px;
                &:last-child{
                    margin: 0;
                }
            }
        }
    }
   
}
</style>
